import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    subtitle1: {
      fontSize: 12,
    },
  },
  components: {
    MuiAccordion: {
      defaultProps: {
        disableGutters: true,
      },
      styleOverrides: {
        root: {
          ':before': {
            opacity: '0',
          },
          color: '#334155',
          margin: '8px 0',
          borderRadius: '8px',
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          padding: '32px 40px',
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: '0 40px',
        },
      },
    },
    MuiAccordionActions: {
      styleOverrides: {
        root: {
          padding: '14px 40px',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          padding: '9px 23px',
          fontSize: '14px',
          fontFamily: 'Roboto',
          lineHeight: '20px',
          textAlign: 'center',
          whiteSpace: 'nowrap',
          borderWidth: '1px',
          boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.05)',
          textTransform: 'none',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: '20px 24px',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '0',
        },
      },
    },
    CardHeader: {
      styleOverrides: {
        title: {},
      },
    },
  },
});

export default theme;
